<template>
	<section class="page-list">
		<span class="jump jump-arrow" :class="{disabled:pstart}" @click="jumpPage(value - 1)"><</span>
		<span v-show="value > 5" class="jump" @click="jumpPage(1)">1</span>
		<span class="jump ellipsis" v-show="efont">...</span>
		<span class="jump" v-for="num in indexs" :key="num" :class="{bgprimary:value === num}" @click="jumpPage(num)">{{num}}</span>
		<span class="jump ellipsis" v-show="ebehind">...</span>
		<span v-show="value < pages-4 && ebehind" class="jump" @click="jumpPage(pages)">{{pages}}</span>
		<span :class="{disabled:pend}" class="jump" @click="jumpPage(value + 1)">></span>

		<!-- <span class="jumppoint">跳转到：</span>
		<span class="jumpinp"><input type="text" v-model="changePage"></span>
		<span class="jump gobtn" @click="jumpPage(changePage)">GO</span> -->
	</section>
</template>

<script>
	export default {
		props: {
			total: {
				type: Number,
				default: 0
			},
			value: {
				type: Number,
				default: 1
			},
			size: {
				type: Number,
				default: 10
			}
		},
		data() {
			return {

			}
		},
		computed: {
			pages: function() {
				return Math.ceil(this.total / this.size);
			},
			show: function() {
				return this.pages && this.pages != 1
			},
			pstart: function() {
				return this.value == 1;
			},
			pend: function() {
				return this.value == this.pages;
			},
			efont: function() {
				if (this.pages <= 7) return false;
				return this.value > 5
			},
			indexs: function() {
				var left = 1,
					right = this.pages,
					ar = [];
				if (this.pages >= 7) {
					if (this.value > 5 && this.value < this.pages - 4) {
						left = Number(this.value) - 3;
						right = Number(this.value) + 3;
					} else {
						if (this.value <= 5) {
							left = 1;
							right = 7;
						} else {
							right = this.pages;

							left = this.pages - 6;
						}
					}
				}
        if(this.pages === 6 && this.value === 6){
          left = 2;
        }
				while (left <= right) {
					ar.push(left);
					left++;
				}
				return ar;
			},
			ebehind: function() {
				if (this.pages <= 7) return false;
				var nowAy = this.indexs;
				return nowAy[nowAy.length - 1] != this.pages;
			}
		},
		methods: {
			jumpPage: function(id) {
				this.$emit('input', id)
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page-list {
		font-size: 0;
		margin-top: 50px;
		text-align: center;

		.jump {
			border: 1px solid #DCDCDC;
			min-width: 30px;
			padding: 0 8px;
			height: 30px;	
			cursor: pointer;
			display: inline-block;
			vertical-align: middle;
			margin-left: 10px;
			background-color: #fff;
			text-align: center;
			font-size:14px;
			font-family:Microsoft YaHei;
			font-weight:400;
			color: #666;
			line-height:28px;
			border-radius:3px;
			&.ellipsis, &.ellipsis:hover{
				background-color: transparent;
				cursor: not-allowed;
				border: none;
				padding: 0;
				min-width: 0;
				line-height: 20px;
			}
			&:hover{
				background-color: #045aea;
				color: #fff;
			}
			&::selection{
				background-color: transparent;
			}
		}
		.jump-arrow{
			margin-left: 0;
		}

		.bgprimary {
			cursor: default;
			color: #fff;
			background: #0260FE;
			border-color: #0260FE;
		}

		input {
			width: 55px;
			height: 26px;
			font-size: 13px;
			border: 1px solid #ccc;
			-webkit-border-radius: 4px;
			-moz-border-radius: 4px;
			border-radius: 4px;
			text-align: center;
		}
		
		.jumppoint {
			margin-left: 30px;
		}

		.gobtn {
			font-size: 12px;
		}

		.jump.disabled {
			pointer-events: none;
			background: #ddd;
			cursor: not-allowed;
		}
	}

</style>
